import { useContext } from 'react'
import { ProvidedMainNavConfigContext } from '../core'
import { Jobibot } from './jobibot'

export function LinkedJobibot({ size = 74 }: { size?: number }) {
	const { logoLinker } = useContext(ProvidedMainNavConfigContext)

	return (
		<>
			{logoLinker({
				children: (
					<>
						<Jobibot size={size} />
					</>
				),
			})}
		</>
	)
}
